import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useContext } from 'react';
import { Typography } from '@chegg-ui/typography';
import { clickBaseEvent } from '@chegg-me-components/utils';
import { FooterLegalContext, rioClient } from '../shared';
import { LegalLinksContainer, LegalLink, LegalText } from '../styles';
/** Function to identify if a particular nav item is an instance of nav link item */

export var isNavLinkItem = function isNavLinkItem(navItem) {
  return 'href' in navItem && !!navItem.href;
};

var LegalLinks = function LegalLinks(_ref) {
  var legalLinks = _ref.legalLinks;

  var _useContext = useContext(FooterLegalContext),
      envUrl = _useContext.envUrl,
      dataTestPrefix = _useContext.dataTestPrefix;

  return /*#__PURE__*/React.createElement(LegalLinksContainer, {
    "data-test": "".concat(dataTestPrefix, "-links-container")
  }, legalLinks === null || legalLinks === void 0 ? void 0 : legalLinks.map(function (navItem, index) {
    if (!isNavLinkItem(navItem)) {
      var _text = navItem.text;
      return /*#__PURE__*/React.createElement(LegalText, {
        variant: "caption",
        "data-test": "".concat(dataTestPrefix, "-text-").concat(index)
      }, _text);
    }

    var text = navItem.text,
        href = navItem.href,
        _onClick = navItem.onClick,
        configuration = navItem.configuration,
        useAbsolute = navItem.useAbsolute,
        target = navItem.target;
    return /*#__PURE__*/React.createElement(LegalLink, {
      className: (configuration === null || configuration === void 0 ? void 0 : configuration.elementClassName) || (configuration === null || configuration === void 0 ? void 0 : configuration.ELEMENT_CLASS),
      id: (configuration === null || configuration === void 0 ? void 0 : configuration.elementId) || (configuration === null || configuration === void 0 ? void 0 : configuration.ELEMENT_ID),
      key: index,
      href: useAbsolute ? href : "".concat(envUrl).concat(href),
      target: target,
      "data-test": "".concat(dataTestPrefix, "-link-").concat(index),
      onClick: function onClick(e) {
        if (_onClick) {
          _onClick(e);
        } else {
          rioClient.sendEvent(_objectSpread(_objectSpread({}, clickBaseEvent), {}, {
            type: 'clickstream_interaction',
            data: {
              interaction: {
                type: 'click',
                element: {
                  name: 'footer menu item',
                  type: 'link',
                  region_name: 'footer',
                  text: text
                }
              }
            }
          }));
        }
      }
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "button",
      variantType: "xs"
    }, text));
  }));
};

LegalLinks.displayName = 'LegalLinks';
export default LegalLinks;